import type * as api from '@gitbook/api-client';
import { Breadcrumbs } from '@gitbook/spine-react';

import { SpaceBreadcrumbItem, SpaceSiteBreadcrumbItem } from '../../../Components';
import { SpaceChangeRequestBreadcrumbItem } from './SpaceChangeRequestBreadcrumbItem';

/**
 * Breadcrumbs for a change request.
 */
export function BreadcrumbsChangeRequest(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
}) {
    const { space, changeRequest } = props;

    return (
        <Breadcrumbs label="Space breadcrumbs">
            <SpaceSiteBreadcrumbItem space={space} />
            <SpaceBreadcrumbItem space={space} iconOnly editable={false} />
            <SpaceChangeRequestBreadcrumbItem
                space={space}
                changeRequest={changeRequest}
                iconOnly={false}
                editable
            />
        </Breadcrumbs>
    );
}
